import styled from "styled-components";

export const ContainerGeneral = styled.div`
  display: flex;
  width: 100%;
  height: calc(100vh - 140px);

  @media (max-width: 768px) {
    height: 100%;
    flex-direction: column;
    gap: 20px;
  }
`;

export const ContainerCodePen = styled.div`
  height: calc(100vh - 140px);
  width: 100%;
`;

export const ContainerHarmonics = styled.div`
  height: calc(100vh - 140px);
  width: auto;
  background-color: #282c34;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;

  @media (max-width: 768px) {
    width: 100%;
    border-radius: 5px;
    border: 1px solid #353841;
  }
`;

export const ContainerTableHarmonic = styled.table`
  border-collapse: collapse;
  display: block;
  overflow-y: scroll;
  overflow-x: scroll;
  width: 100%;
  height: calc(100vh - 365px);
`;

export const ContainerTableHarmonicHead = styled.thead``;

export const ContainerRowHarmonicHead = styled.tr``;

export const ContainerColumnHarmonicHead = styled.th``;

export const ContainerCellHarmonicHead = styled.div`
  padding: 8px;
  text-align: left;
`;

export const ContainerCellTextHarmonicHead = styled.span`
  color: white;
  font-family: "Inter";
  font-size: 13px;
  font-weight: 500;
  line-height: 24px;
`;

export const ContainerTableHarmonicBody = styled.tbody``;

export const ContainerRowHarmonicBody = styled.tr`
  border-bottom: 1px solid #3a3a3a;
  &:last-child {
    border-bottom: none;
  }
  cursor: pointer;
`;

export const ContainerColumnHarmonicBody = styled.td``;

export const ContainerCellHarmonicBody = styled.div`
  padding: 8px;
  text-align: left;
`;

export const ContainerCellTextHarmonicBody = styled.span`
  color: white;
  font-family: "Inter";
  font-size: 13px;
  font-weight: 500;
  line-height: 24px;
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const CloseButton = styled.button`
  color: "red";
  margin-top: 20px;
  background-color: #31bcc0;
  padding: 8px 8px 8px 8px;
  text-decoration: none;
  border: none;
  color: white;
  cursor: pointer;
`;

export const SubActionsContainer = styled.div`
  justify-content: right;
  display: flex;
  width: 100%;
`;

export const SubModalContainer = styled.div`
  position: "relative";
  overflow-y: scroll;
  height: 293px;
  padding: 20px;
`;

export const ContainerFilters = styled.div`
  width: auto;
  padding: 12px 16px 12px 16px;
  gap: 22px;

  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 100%;
    gap: 10px;
    padding: 10px;
  }
`;

export const SearchSymbolInput = styled.input`
  background: transparent;
  border: none;
  font-family: "Roboto";
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  height: 22px;
  width: 100%;
  color: white;
`;

export const ContainerSearchSymbolInput = styled.div`
  padding: 5px 12px 5px 12px;
  border-radius: 20px;
  background-color: #7b7b7b;
  display: flex;
  gap: 4px;
  background: linear-gradient(349.74deg, #24282f -2.06%, #16181d 102.08%);
  align-items: center;
  padding: 5px 12px;

  @media (max-width: 768px) {
    width: 50%;
  }
`;

export const ImgSearchSymbol = styled.img`
  width: 14px;
  height: 14px;
`;

export const ContainerFiltersBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  width: 60%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const FilterButton = styled.button`
  height: 31px;
  padding: 6px 16px 6px 16px;
  gap: 10px;
  border-radius: 100px;
  border: 1px solid #ffffff;
  background: transparent;

  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 400;
  line-height: 19.07px;
  text-align: left;
  color: #ffffff;
  text-align: center;
  align-items: center;
  display: flex;
  cursor: pointer;
  position: relative;
`;

export const FilterButton2 = styled.div`
  height: 31px;
  padding: 0px 16px 0px 16px;
  gap: 10px;
  border-radius: 100px;
  border: 1px solid #ffffff;
  background: transparent;

  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 400;
  line-height: 19.07px;
  text-align: left;
  color: #ffffff;
  text-align: center;
  align-items: center;
  display: flex;
  cursor: pointer;
  position: relative;
`;

export const ModalOptions = styled.div`
  position: absolute;
  width: 500px;
  padding: 16px;
  gap: 6px;
  border-radius: 10px;
  background: #24282f;
  z-index: 50;
  left: -540px;
  top: 30px;
  cursor: default;
  color: white;

  @media (max-width: 768px) {
    top: calc(100% + 8px);
    left: 80%;
    transform: translateX(-50%);
    min-width: 0;
    width: 350px;
  }
`;

export const TitleOptions = styled.span`
  font-family: "SF Pro Text";
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;

  width: auto;
  height: 30px;
  padding: 6px 16px 6px 16px;
  gap: 10px;

  border-bottom: 1px solid #5ac9cd;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContainerGridOptions = styled.div`
  display: grid;
  /* grid-template-rows: 100px 100px 100px; */
  grid-template-columns: 150px 150px 150px;
  grid-gap: 5px;
  justify-content: space-between;
  align-content: center;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    grid-template-columns: 100px 100px 100px;
  }
`;

export const GridOption = styled.div`
  display: flex;
  align-items: center;
`;

export const CheckBox = styled.input``;

export const TitleGridOption = styled.span`
  font-family: "Inter";
  font-size: 13.21px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

export const Circle = styled.div`
  width: 7px;
  height: 7px;
  border-radius: 50%;
`;

export const ArrowUpORDown = styled.img`
  margin-right: 10px;
`;

export const ResponsiveContainerFilter = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  gap: 15px;
  padding: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
    padding: 10px;

    align-items: flex-start;
  }
`;
